const LINKS = {
  REFER_FRIENDS_CAMPAIGN: "/campaign/refer_friends.html",
  ONE_CLICK_ESTIMATE: "/kiban/com/csComEst.do",
  MY_PAGE_TOP: "/kiban/com/csComTop.do",
} as const

export default LINKS
